import { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "rsuite";
import { format } from 'date-fns';
import Select from 'react-select';
import {
    setOptionApproverEmployeeValue, setDateRangeValue, getAccountTimeOffTypesByAccountIdAndIsDisabledAsync,
    getEmployeesForTimeOffApprovalAsync, setOptionTimeOffTypesValue, filterTimeOffApproval, getAllTimeOffApprovedEntriesAsync,
    updateisTimeOffApprovaltab,
    getAllTimeOffApprovalEntriesAsync
} from './TimeOffApprovalSlice';
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { dropDownSelectionStyles, dateFormatByAccountCulture, normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import DatePickerRanges from "../../../common/DatePickerRanges";

const TimeOffApprovalFilter = (props: any) => {
    const { t } = props;
    const { timeOffTypesList,isTimeOffApprovaltab } = useAppSelector((state) => state.timeOffApproval)
    const { IsShowEmployeeNameWithCode } = useAppSelector((state) => state.timesheet);
    const { maxMenuHeight, sessionAccountEmployeeId, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat } = useAppSelector((state) => state.globalState);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [selectedApproverEmployeeOptionDropDownAttendance, setSelectedApproverEmployeeOptionDropDownAttendance] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
    const [EmployeeNameArray, setEmployeeNameArray] = useState<any | ''>([]);
    const [selectedTimeOffTypesOptionDropDown, setSelectedTimeOffTypesOptionDropDown] = useState<{ [object: string]: any }>({ value: '0', label: 'All' });
    const [includeDateRange, setIncludeDateRange] = useState<boolean>(false);
    const [displayedRange, setDisplayedRange] = useState('Please Select Date Range');
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getAccountTimeOffTypesByAccountIdAndIsDisabledAsync());
        dispatch(getEmployeesForTimeOffApprovalAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                originalPromiseResult.Data.map((item: any) => {
                    if (IsShowEmployeeNameWithCode) {
                        item.value = item.AccountEmployeeId;
                        item.label = item.EmployeeNameWithCode;
                    }
                    else {
                        item.value = item.AccountEmployeeId;
                        item.label = item.FullName;
                    }
                });
                originalPromiseResult.Data.unshift({ value: '0', label: 'All' })
                setEmployeeNameArray(originalPromiseResult.Data);

            }).catch((rejectedValueOrSerializedError) => {
            });
    }, []);

    const handleDateRangeChange = (value: any) => {
        if (value !== undefined && value !== null) {
            // setStartDate(value[0]);
            // setEndDate(value[1]);
            // dispatch(setDateRangeValue({ startDate: value[0].toISOString(), endDate: value[1].toISOString() }))
            if (value && value[0] && value[1]) {
                const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
                const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
                setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
            } else {
                setDisplayedRange('Please Select Date Range');
            }
            // setStartDate(dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()));
            // setEndDate(dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()));
            // dispatch(setDateRangeValue({ startDate: dateFormatByAccountCulture(value[0].toISOString(), cultureInfoName.toString()), endDate: dateFormatByAccountCulture(value[1].toISOString(), cultureInfoName.toString()) }));
            setStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
            setEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
            dispatch(setDateRangeValue({ startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd") }));
        }
    }

    const handleApproverEmployeeChange = (data: any) => {
        const { value, label } = data;
        setSelectedApproverEmployeeOptionDropDownAttendance({ value: value, label: label });
        dispatch(setOptionApproverEmployeeValue({ value: value, label: label }));
    }

    const handleTimeOffTypesChange = (data: any) => {
        const { value, label } = data;
        setSelectedTimeOffTypesOptionDropDown({ value: value, label: label });
        dispatch(setOptionTimeOffTypesValue({ value: value, label: label }));
    }

    const handleResetFiltersOnClickEvent = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        setSelectedApproverEmployeeOptionDropDownAttendance({ value: '0', label: 'All' });
        dispatch(setOptionApproverEmployeeValue({ value: '0', label: 'All' }));
        setSelectedTimeOffTypesOptionDropDown({ value: '0', label: 'All' });
        dispatch(setOptionTimeOffTypesValue({ value: '0', label: 'All' }));
        setIncludeDateRange(false);
        if (!isTimeOffApprovaltab) {
            const timeofftypeid =  "00000000-0000-0000-0000-000000000000";
            dispatch(getAllTimeOffApprovedEntriesAsync({ AccountTimeOffTypeId: timeofftypeid, TimeOffAccountEmployeeId: selectedApproverEmployeeOptionDropDownAttendance.value, IncludeDateRange: true, StartDate: moment(new Date()).subtract(1, 'months').format('MM-DD-YYYY'), EndDate: moment(new Date()).add(1, 'months').format('MM-DD-YYYY') }));
        }
    }

    const handleApplyFilterOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        if (isTimeOffApprovaltab) {
            const timeofftypeid = selectedTimeOffTypesOptionDropDown.value == 0 ? "00000000-0000-0000-0000-000000000000" : selectedTimeOffTypesOptionDropDown.value;
            // dispatch(filterTimeOffApproval({ AccountTimeOffTypeId: selectedTimeOffTypesOptionDropDown.value, TimeOffAccountEmployeeId: selectedApproverEmployeeOptionDropDownAttendance.value, IncludeDateRange: includeDateRange, StartDate: moment(startDate).format(dateInsertionFormat), EndDate: moment(endDate).format(dateInsertionFormat), AccountEmployeeId: sessionAccountEmployeeId, }));
             dispatch(getAllTimeOffApprovalEntriesAsync({ AccountTimeOffTypeId: timeofftypeid, TimeOffAccountEmployeeId: selectedApproverEmployeeOptionDropDownAttendance.value, IncludeDateRange: includeDateRange, StartDate: moment(startDate).format(dateInsertionFormat), EndDate: moment(endDate).format(dateInsertionFormat)}));
        } else {
            const timeofftypeid = selectedTimeOffTypesOptionDropDown.value == 0 ? "00000000-0000-0000-0000-000000000000" : selectedTimeOffTypesOptionDropDown.value;
            dispatch(getAllTimeOffApprovedEntriesAsync({ AccountTimeOffTypeId: timeofftypeid, TimeOffAccountEmployeeId: selectedApproverEmployeeOptionDropDownAttendance.value, IncludeDateRange: includeDateRange, StartDate: moment(startDate).format("MM-DD-YYYY"), EndDate: moment(endDate).format("MM-DD-YYYY") }));
        }
    }

    const handleIncludeDateRangeChange = (e: any) => {
        setIncludeDateRange(e.target.checked);
    }

    return (
        <>
            <div className='card-body'>
                <div className='row'>
                    <div className="col-md-12">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Date Range')} */}
                            {getValueFromResource('Date Range',dispatch, t)}
                            </label>
                        <DateRangePicker
                            onChange={handleDateRangeChange}
                            ranges={DatePickerRanges() }
                            value={[startDate, endDate]}
                            // placeholder={t('Please Select Date Range')}
                            placeholder={displayedRange}
                            character={' - '}
                            cleanable={false}
                            placement="bottomEnd"
                            format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                        >
                        </DateRangePicker>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Employee Name')} */}
                            {getValueFromResource('Employee Name',dispatch, t)}                            
                            </label>
                        <div>
                            <Select
                                value={selectedApproverEmployeeOptionDropDownAttendance}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="ApproverEmployeeList"
                                onChange={handleApproverEmployeeChange}
                                options={EmployeeNameArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className='col-md-12'>
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Time Off Types')} */}
                            {getValueFromResource('Time Off Types',dispatch, t)}
                            </label>
                        <div>
                            <Select
                                value={selectedTimeOffTypesOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="timeOffTypesList"
                                onChange={handleTimeOffTypesChange}
                                options={timeOffTypesList}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>
                <div className='row mt-6'>
                    <div className="col-md-12 mb-2">
                        <label className="form-label fs-7 fw-normal mb-2">
                            {/* {t('Include Date Range')} */}
                            {getValueFromResource('Include Date Range',dispatch, t)}
                            </label>
                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                            <input className="form-check-input h-20px w-30px"
                                type="checkbox"
                                checked={includeDateRange}
                                onChange={(e: any) => handleIncludeDateRangeChange(e)}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                            {/* {t('Apply Filter')} */}
                            {getValueFromResource('Apply Filter',dispatch, t)}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2 fs-7"
                            data-kt-element='send'
                            onClick={handleResetFiltersOnClickEvent}
                        >
                            {/* {t('Reset Filters')} */}
                            {getValueFromResource('Reset Filters',dispatch, t)}
                        </button>
                        <button
                            type="button"
                            data-kt-element='send'
                            className="btn btn-primary btn-sm fs-7"
                            onClick={handleApplyFilterOnClickEvent}
                        >
                            <i className="bi bi-filter fs-5 me-1"></i>
                            {/* {t('Apply Filters')} */}
                            {getValueFromResource('Apply Filters',dispatch, t)}
                            </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TimeOffApprovalFilter;